export const GET_LAND_CLASSIFICATIONS = '/land/get_land_classifications';
export const GET_SINGLE_LAND_CLASS = '/land/get_single_land_class';
export const CREATE_LAND_CLASSIFICATION = '/land/create_land_classifications';
export const UPDATE_LAND_CLASSIFICATION = '/land/update_land_classifications';
export const REMOVE_LAND_CLASSIFICATION = '/land/remove_transaction_code_land_classifications';

export const CREATE_LAND_SUB_CLASS = 'MODULE_SYSTEM/create_land_sub_class';
export const UPDATE_LAND_SUB_CLASS = 'MODULE_SYSTEM/update_land_sub_class';
export const REMOVE_LAND_SUB_CLASS = 'MODULE_SYSTEM/remove_land_sub_class';

export const CREATE_LAND_SUB_ITEM = 'MODULE_SYSTEM/create_land_sub_item';
export const UPDATE_LAND_SUB_ITEM = 'MODULE_SYSTEM/update_land_sub_item';
export const REMOVE_LAND_SUB_ITEM = 'MODULE_SYSTEM/remove_land_sub_item';

export const GET_ORDINANCE_REVISION = 'sub-classification/get_ordinance_revision';
export const GET_PROVINCE = 'NEW_BUSINESSES/get_provinces';
export const GET_MUNICIPALITIES = 'NEW_BUSINESSES/get_municipalities';
export const GET_BARANGAYS = 'NEW_BUSINESSES/get_barangays';
export const GET_LAND_SUB_CLASSIFICATIONS = "LAND_SETTINGS/get_land_sub_classifications";
export const GET_LAND_SUB_CLASSIFICATIONS_ITEMS = "LAND_SETTINGS/get_land_sub_classifications_items";

export const FORM_DATA = {
  name: '',
  description: '',
  unit_value: '',
  ordinance_revision_id: '',
  is_active: false,
};